import React, { FunctionComponent } from 'react';
import styles from '../atoms.module.scss';

const SwitchButtonHorizontalGroup: FunctionComponent<any> = ({ children }) => {
  return <div className={styles.switchButtonHorizontalGroup}>{children}</div>;
};

export default SwitchButtonHorizontalGroup;
